import React from "react";
import { clsx } from "clsx";
import { getInitials } from "../../../common/components/NameAvatar";
import { useUserState } from "../../../common/UserContext";
import type { ChatMessage } from "../useGuidedIntake";
import classes from "../GuidedIntake.module.less";

export const BrandMark: React.FC = () => (
    <svg viewBox="0 0 110 61" fill="none" aria-label="Infinity Loop">
        <path
            d="M108.9083736,24.6111203L87.5611864,3.26393c-2.9444372-2.94444-7.7291564-2.94444-10.6735936,0l-36.6214753,36.4374449c-2.7604125,2.5763843-7.3611,5.1527686-11.0416518,5.1527686-4.0486047,0-8.0972093-1.840275-10.8576218-4.7847157-2.7604125-3.1284689-4.0486047-7.1770718-3.68055-11.4097047.7361111-6.8090172,6.2569343-12.145814,13.0659532-12.6978986h1.4722204c3.68055,0,7.1770753,1.2881922,9.7534596,3.8645782l6.4409625,6.4409625c.5520811.5520829,1.6562468.5520829,2.2083314,0l7.3611-7.3611c.5520811-.5520829.5520811-1.6562468,0-2.2083297l-4.4166593-4.4166602-2.0243067-2.0243006-.1840282-.1840273c-5.8888814-5.520825-13.8020625-8.2812375-21.7152471-7.5451273C13.3980991,3.8160124,2.908532,14.1215523,1.4363119,27.1875046c-.9201375,7.9131829,1.6562473,15.826364,6.993045,21.7152454,5.3367977,5.8888814,12.8819241,9.3854032,20.795107,9.3854032,10.121516,0,18.2187218-6.8090189,20.4270532-8.8333221l31.6527314-31.284675c.5520811-.5520829,1.6562503-.5520829,2.2083314,0l11.2256747,11.2256782c.5520811.5520829.5520811,1.6562468,0,2.2083314l-11.2256747,11.2256782c-.5520811.5520811-1.6562503.5520811-2.2083314,0l-8.4652622-8.4652657c-.5520811-.5520811-1.6562503-.5520811-2.2083314,0l-7.3611,7.3611c-.5520811.5520811-.5520811,1.6562468,0,2.2083314l13.6180378,13.6180343c1.4722186,1.6562468,3.4965183,2.3923561,5.3367933,2.3923561s3.8645747-.7361093,5.3368003-2.2083314l21.3471872-21.3471907c4.0486064-3.8645747,3.68055-8.0972076,0-11.7777576h0Z"
            fill="#24b2ee"
        />
    </svg>
);

export const MessageBubble: React.FC<{ message: ChatMessage }> = ({ message }) => {
    const { me } = useUserState();
    const userInitials = (getInitials(me.name || me.email || "user")).toUpperCase();
    if (message.typing) {
        return (
            <div className={clsx(classes.message, classes.messageFromBot)}>
                <div className={clsx(classes.messageAvatar, classes.messageAvatarBrand)}>
                    <BrandMark />
                </div>
                <div className={classes.messageBody}>
                    <div className={classes.typing}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </div>
        );
    }

    // Upload read-backs are interjections, not agent turns — same bot avatar,
    // but the body reads as a labeled document note.
    if (message.interjection) {
        return (
            <div className={clsx(classes.message, classes.messageFromBot)}>
                <div className={clsx(classes.messageAvatar, classes.messageAvatarBrand)}>
                    <BrandMark />
                </div>
                <div className={classes.messageBody}>
                    <div className={classes.interjection}>
                        <div className={classes.interjectionLabel}>From your documents</div>
                        {message.content}
                    </div>
                </div>
            </div>
        );
    }

    const isBot = message.role === "system";
    return (
        <div
            className={clsx(
                classes.message,
                isBot ? classes.messageFromBot : classes.messageFromUser
            )}
        >
            <div className={clsx(classes.messageAvatar, isBot && classes.messageAvatarBrand)}>
                {isBot ? <BrandMark /> : userInitials}
            </div>
            <div className={classes.messageBody}>
                <div className={clsx(classes.bubbleContent, classes.bubbleLong)}>
                    {message.content}
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
